import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15 6a3 3 0 1 1 .917 2.16l-6.94 3.47a3 3 0 0 1 0 .74l6.94 3.47a3 3 0 1 1-.895 1.789l-6.94-3.47a3 3 0 1 1 0-4.319l6.94-3.47A3 3 0 0 1 15 6"
    }
  )
);
var SvgShareFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ShareFilled_default = SvgShareFilled;

export { ShareFilled_default as default };
